export default __webpack_public_path__ + "static/media/belaro.063549aa.jpg";